(function () {
  console.log('[Product Info] Script loaded');
  
  document.addEventListener("DOMContentLoaded", function () {
    console.log('[Product Info] DOM Content Loaded');
    
    // Debug: Check for cart-notification element
    var cartNotificationCheck = document.querySelector('cart-notification');
    console.log('[Product Info] cart-notification exists:', !!cartNotificationCheck);
    if (cartNotificationCheck) {
      console.log('[Product Info] cart-notification HTML:', cartNotificationCheck.innerHTML.substring(0, 200));
    }
    
    // Find all product showcase sections
    var sections = document.querySelectorAll(".community-product-showcase");
    console.log('[Product Info] Found sections:', sections.length);

    sections.forEach(function (root) {
      var sectionId = root.id.replace("community-product-showcase-", "");
      var thumbs = document.getElementById("community-thumbs-" + sectionId);
      var dots = document.getElementById("community-dots-" + sectionId);
      var main = document.getElementById("community-main-image-" + sectionId);
      var qtyInput = root.querySelector(".community-qty-input");
      var decBtn = root.querySelector(".community-qty-decrease");
      var incBtn = root.querySelector(".community-qty-increase");
      var thumbEls = thumbs
        ? thumbs.querySelectorAll(".community-gallery__thumb")
        : [];
      var dotEls = dots
        ? dots.querySelectorAll(".community-gallery__dot")
        : [];
      
      // Store original images for switching back
      var originalThumbsHTML = thumbs ? thumbs.innerHTML : '';
      var originalMainHTML = main ? main.innerHTML : '';
      var originalDotsHTML = dots ? dots.innerHTML : '';
      var currentMode = 'features';
      var currentIndex = 0;
      var totalItems = 0;

      // Navigation arrows
      var navPrev = root.querySelector('.community-gallery__nav--prev');
      var navNext = root.querySelector('.community-gallery__nav--next');

      // Initialize total items count
      function updateTotalItems() {
        if (currentMode === 'features') {
          totalItems = thumbEls.length;
        } else {
          var videoThumbs = thumbs ? thumbs.querySelectorAll('.community-gallery__thumb') : [];
          totalItems = videoThumbs.length;
        }
      }
      updateTotalItems();

      // Navigate to specific index
      function navigateToIndex(index) {
        if (totalItems === 0) return;
        
        // Wrap around
        if (index < 0) index = totalItems - 1;
        if (index >= totalItems) index = 0;
        
        currentIndex = index;
        
        var allThumbs = thumbs ? thumbs.querySelectorAll('.community-gallery__thumb') : [];
        if (allThumbs[index]) {
          allThumbs[index].click();
          // 滚动缩略图到可见区域
          scrollToThumbnail(index);
        }
      }

      // Arrow navigation click handlers
      if (navPrev) {
        navPrev.addEventListener('click', function(e) {
          e.stopPropagation();
          navigateToIndex(currentIndex - 1);
        });
      }
      if (navNext) {
        navNext.addEventListener('click', function(e) {
          e.stopPropagation();
          navigateToIndex(currentIndex + 1);
        });
      }

      // Keyboard navigation
      document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          navigateToIndex(currentIndex - 1);
        } else if (e.key === 'ArrowRight') {
          navigateToIndex(currentIndex + 1);
        }
      });

      // Touch swipe for mobile
      var touchStartX = 0;
      var touchEndX = 0;
      var touchStartY = 0;
      var touchEndY = 0;
      var minSwipeDistance = 50; // minimum distance for swipe
      var isSwiping = false;

      if (main) {
        main.addEventListener('touchstart', function(e) {
          touchStartX = e.changedTouches[0].screenX;
          touchStartY = e.changedTouches[0].screenY;
          isSwiping = false;
        }, { passive: true });

        main.addEventListener('touchmove', function(e) {
          // Detect if user is swiping horizontally
          var currentX = e.changedTouches[0].screenX;
          var currentY = e.changedTouches[0].screenY;
          var deltaX = Math.abs(currentX - touchStartX);
          var deltaY = Math.abs(currentY - touchStartY);
          
          // If horizontal movement is greater, mark as swiping
          if (deltaX > deltaY && deltaX > 10) {
            isSwiping = true;
          }
        }, { passive: true });

        main.addEventListener('touchend', function(e) {
          touchEndX = e.changedTouches[0].screenX;
          touchEndY = e.changedTouches[0].screenY;
          if (isSwiping) {
            handleSwipe();
          }
        }, { passive: true });
      }

      function handleSwipe() {
        var deltaX = touchEndX - touchStartX;
        var deltaY = touchEndY - touchStartY;
        
        // Check if horizontal swipe is greater than vertical (to avoid conflict with scrolling)
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
          if (deltaX > 0) {
            // Swipe right - go to previous
            navigateToIndex(currentIndex - 1);
          } else {
            // Swipe left - go to next
            navigateToIndex(currentIndex + 1);
          }
        }
      }

      // thumbnail click -> swap main image
      if (thumbEls.length) {
        thumbEls.forEach(function (t, index) {
          t.addEventListener("click", function () {
            // remove active from thumbnails
            thumbEls.forEach(function (x) {
              x.classList.remove("is-active");
            });
            t.classList.add("is-active");
            
            // sync dots
            if (dotEls.length) {
              dotEls.forEach(function (d) {
                d.classList.remove("is-active");
              });
              if (dotEls[index]) {
                dotEls[index].classList.add("is-active");
              }
            }
            
            currentIndex = index;
            // 滚动缩略图到可见区域
            scrollToThumbnail(index);
            var src = t.getAttribute("data-src");
            if (src) {
              var img = main.querySelector("img");
              // fade
              img.style.opacity = 0;
              setTimeout(function () {
                img.src = src;
                img.setAttribute(
                  "data-image-index",
                  t.getAttribute("data-index") || "0"
                );
                img.style.opacity = 1;
              }, 160);
            }
          });
        });
      }

      // dot click -> sync with thumbnails
      if (dotEls.length) {
        dotEls.forEach(function (dot, index) {
          dot.addEventListener("click", function () {
            if (thumbEls[index]) {
              thumbEls[index].click();
              // 滚动缩略图到可见区域
              scrollToThumbnail(index);
            }
          });
        });
      }

      // Remove sticky title behavior
      var stickyTitle = root.querySelector('.community-title--sticky');
      if (stickyTitle) {
        stickyTitle.classList.remove('is-fixed');
        stickyTitle.classList.remove('is-scrolled');
      }

      // qty buttons
      function clampQty() {
        var v = parseInt(qtyInput.value) || 1;
        if (v < 1) v = 1;
        qtyInput.value = v;
      }
      if (decBtn)
        decBtn.addEventListener("click", function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) - 1);
        });
      if (incBtn)
        incBtn.addEventListener("click", function () {
          qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
        });

      // accordions
      var heads = root.querySelectorAll(".community-accordion__head");
      heads.forEach(function (head) {
        head.addEventListener("click", function () {
          var item = head.closest('.community-accordion__item');
          var target = head.getAttribute("data-target");
          var body = document.getElementById(target);
          if (!body) return;
          
          var isOpen = item.classList.contains('is-open');
          
          // Close all other accordions in this section
          var allItems = root.querySelectorAll(".community-accordion__item");
          allItems.forEach(function (otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
            }
          });
          
          // Toggle current accordion
          if (!isOpen) {
            item.classList.add('is-open');
          } else {
            item.classList.remove('is-open');
          }
        });
      });

      // Accessibility: keyboard on thumbs
      thumbEls.forEach(function (t) {
        t.setAttribute("tabindex", 0);
        t.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            t.click();
          }
        });
      });
      
      // Add click to navigate to product detail page
      var galleryMain = root.querySelector('.community-gallery__main');
      var productTitle = root.querySelector('.community-title');
      
      // Get product URL from the section
      function getProductUrl() {
        // Try to get from window location if we're on a product page
        if (window.location.pathname.includes('/products/')) {
          return window.location.href;
        }
        
        // Try to get from product data in the page
        var productHandle = root.getAttribute('data-product-handle');
        if (productHandle) {
          return '/products/' + productHandle;
        }
        
        // Fallback: try to find product link in the section
        var productLink = root.querySelector('a[href*="/products/"]');
        if (productLink) {
          return productLink.getAttribute('href');
        }
        
        return null;
      }
      
      // Add click handler to gallery main image
      if (galleryMain) {
        console.log('[Product Nav] Setting up gallery click handler');
        galleryMain.style.cursor = 'pointer';
        galleryMain.addEventListener('click', function(e) {
          console.log('[Product Nav] Gallery clicked, target:', e.target);
          
          // Don't navigate if clicking on navigation arrows, zoom button, or video/iframe
          if (e.target.closest('.community-gallery__nav') || 
              e.target.closest('.community-gallery__zoom-btn') ||
              e.target.tagName === 'VIDEO' ||
              e.target.tagName === 'IFRAME') {
            console.log('[Product Nav] Click ignored - special element');
            return;
          }
          
          var productUrl = getProductUrl();
          console.log('[Product Nav] Product URL:', productUrl);
          
          if (productUrl) {
            console.log('[Product Nav] Navigating to:', productUrl);
            window.location.href = productUrl;
          } else {
            console.warn('[Product Nav] No product URL found');
          }
        });
      } else {
        console.warn('[Product Nav] Gallery main element not found');
      }
      
      // Add click handler to product title
      if (productTitle) {
        console.log('[Product Nav] Setting up title click handler');
        productTitle.style.cursor = 'pointer';
        productTitle.addEventListener('click', function(e) {
          console.log('[Product Nav] Title clicked');
          var productUrl = getProductUrl();
          console.log('[Product Nav] Product URL:', productUrl);
          
          if (productUrl) {
            console.log('[Product Nav] Navigating to:', productUrl);
            window.location.href = productUrl;
          } else {
            console.warn('[Product Nav] No product URL found');
          }
        });
      } else {
        console.warn('[Product Nav] Product title element not found');
      }

      // Features/Videos toggle buttons
      var btnFeatures = root.querySelector(".community-btn-features");
      var btnVideos = root.querySelector(".community-btn-videos");

      function switchToFeatures() {
        if (currentMode === 'features') return;
        
        // Restore original content
        if (thumbs) thumbs.innerHTML = originalThumbsHTML;
        if (main) main.innerHTML = originalMainHTML;
        if (dots) dots.innerHTML = originalDotsHTML;
        
        // Update button styles
        btnFeatures.classList.add('active');
        btnFeatures.style.borderColor = '#ffbfa0';
        btnFeatures.style.color = 'var(--accent)';
        btnVideos.classList.remove('active');
        btnVideos.style.borderColor = '#eee';
        btnVideos.style.color = '';
        
        // Update thumbEls and dotEls references
        thumbEls = thumbs ? thumbs.querySelectorAll('.community-gallery__thumb') : [];
        dotEls = dots ? dots.querySelectorAll('.community-gallery__dot') : [];
        
        // Re-bind thumbnail events
        rebindThumbnails();
        
        // Re-bind arrow navigation events
        navPrev = main.querySelector('.community-gallery__nav--prev');
        navNext = main.querySelector('.community-gallery__nav--next');
        
        if (navPrev) {
          navPrev.addEventListener('click', function(e) {
            e.stopPropagation();
            navigateToIndex(currentIndex - 1);
          });
        }
        if (navNext) {
          navNext.addEventListener('click', function(e) {
            e.stopPropagation();
            navigateToIndex(currentIndex + 1);
          });
        }
        
        currentMode = 'features';
        currentIndex = 0;
        updateTotalItems();
        // 滚动到第一个缩略图
        setTimeout(function() {
          scrollToThumbnail(0);
        }, 100);
      }

      function switchToVideos() {
        if (currentMode === 'videos') return;
        
        var videosData = btnVideos.getAttribute('data-videos');
        if (!videosData || videosData === '') {
          console.log('No videos available');
          return;
        }

        // Parse video URLs (assuming comma-separated or JSON format)
        var videoUrls = [];
        try {
          // Try parsing as JSON first
          var parsedData = JSON.parse(videosData);
          
          // Handle different data structures
          if (Array.isArray(parsedData)) {
            // Array of URLs or objects
            videoUrls = parsedData.map(function(item) {
              if (typeof item === 'string') {
                return item;
              } else if (item && item.url) {
                // Shopify file object with url property
                return item.url;
              } else if (item && item.sources) {
                // Video with sources array
                return item.sources && item.sources[0] ? item.sources[0].url : null;
              }
              return null;
            }).filter(function(url) { return url; });
          } else if (parsedData && typeof parsedData === 'object') {
            // Single object
            if (parsedData.url) {
              videoUrls = [parsedData.url];
            } else if (parsedData.sources && parsedData.sources[0]) {
              videoUrls = [parsedData.sources[0].url];
            }
          }
        } catch (e) {
          console.log('JSON parse error, trying comma-separated format');
          // If not JSON, try comma-separated
          videoUrls = videosData.split(',').map(function(url) { return url.trim(); }).filter(function(url) { return url; });
        }

        if (!videoUrls || videoUrls.length === 0) {
          console.log('No valid video URLs found');
          console.log('Raw data:', videosData);
          return;
        }
        
        console.log('Parsed video URLs:', videoUrls);

        // Update main area with first video
        var firstVideoUrl = videoUrls[0];
        var videoHTML = createVideoEmbed(firstVideoUrl);
        if (main) {
          main.innerHTML = videoHTML;
        }

        // Update thumbnails with video previews
        if (thumbs) {
          var thumbsHTML = '';
          videoUrls.forEach(function(url, index) {
            var thumbVideoHTML = createVideoThumbnail(url, index);
            thumbsHTML += '<div class="community-gallery__thumb ' + (index === 0 ? 'is-active' : '') + '" data-video-url="' + url + '" data-index="' + index + '" data-type="video">' + thumbVideoHTML + '</div>';
          });
          console.log('Setting thumbnails HTML, count:', videoUrls.length);
          thumbs.innerHTML = thumbsHTML;
          console.log('Thumbnails container after update:', thumbs.children.length, 'children');
        }

        // Update dots for video mode
        if (dots) {
          var dotsHTML = '';
          videoUrls.forEach(function(url, index) {
            dotsHTML += '<span class="community-gallery__dot ' + (index === 0 ? 'is-active' : '') + '" data-dot-index="' + index + '"></span>';
          });
          dots.innerHTML = dotsHTML;
          console.log('Updated dots for videos, count:', videoUrls.length);
        }

        // Update button styles
        btnVideos.classList.add('active');
        btnVideos.style.borderColor = '#ffbfa0';
        btnVideos.style.color = 'var(--accent)';
        btnFeatures.classList.remove('active');
        btnFeatures.style.borderColor = '#eee';
        btnFeatures.style.color = '';

        // Bind video thumbnail events
        rebindThumbnails();
        currentMode = 'videos';
        currentIndex = 0;
        updateTotalItems();
        // 滚动到第一个缩略图
        setTimeout(function() {
          scrollToThumbnail(0);
        }, 100);
      }

      function createVideoEmbed(url) {
        console.log('Creating video embed for:', url);
        
        // Clean up URL
        url = url.trim();
        
        // Support YouTube, Vimeo, and direct video URLs
        var youtubeMatch = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
        var vimeoMatch = url.match(/vimeo\.com\/(\d+)/i);

        if (youtubeMatch) {
          // Use fixed height container for main gallery display
          return '<div style="position:relative;width:100%;height:540px;max-height:540px;border-radius:8px;overflow:hidden;background:#000;">' +
                 '<iframe src="https://www.youtube.com/embed/' + youtubeMatch[1] + '?autoplay=0&rel=0&modestbranding=1" ' +
                 'style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" ' +
                 'allowfullscreen loading="lazy"></iframe>' +
                 '</div>';
        } else if (vimeoMatch) {
          // Use fixed height container for main gallery display
          return '<div style="position:relative;width:100%;height:540px;max-height:540px;border-radius:8px;overflow:hidden;background:#000;">' +
                 '<iframe src="https://player.vimeo.com/video/' + vimeoMatch[1] + '" ' +
                 'style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" ' +
                 'allowfullscreen loading="lazy"></iframe>' +
                 '</div>';
        } else {
          // Direct video file - detect type from URL or default to mp4
          var videoType = 'video/mp4';
          if (url.toLowerCase().indexOf('.webm') > -1) {
            videoType = 'video/webm';
          } else if (url.toLowerCase().indexOf('.ogg') > -1) {
            videoType = 'video/ogg';
          } else if (url.toLowerCase().indexOf('.mov') > -1) {
            videoType = 'video/quicktime';
          }
          
          // Use similar styling to accordion video for consistency
          return '<video controls playsinline preload="metadata" style="width:100%;max-width:100%;max-height:540px;border-radius:8px;background:#000;display:block;object-fit:contain;">' +
                 '<source src="' + url + '" type="' + videoType + '">' +
                 'Your browser does not support the video tag.' +
                 '</video>';
        }
      }

      function createVideoThumbnail(url, index) {
        console.log('Creating thumbnail for video:', url);
        
        var youtubeMatch = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
        var vimeoMatch = url.match(/vimeo\.com\/(\d+)/i);
        
        if (youtubeMatch) {
          // Use YouTube thumbnail
          var thumbnailUrl = 'https://img.youtube.com/vi/' + youtubeMatch[1] + '/mqdefault.jpg';
          console.log('YouTube thumbnail:', thumbnailUrl);
          return '<img src="' + thumbnailUrl + '" alt="Video ' + (index + 1) + '" style="width:100%;height:100%;object-fit:cover;display:block;">';
        } else if (vimeoMatch) {
          // Vimeo - use generic icon with better styling
          return '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg, #667eea 0%, #764ba2 100%);position:relative;">' +
                 '<svg width="40" height="40" viewBox="0 0 24 24" fill="white" style="filter:drop-shadow(0 2px 4px rgba(0,0,0,0.2));"><path d="M8 5v14l11-7z"/></svg>' +
                 '<span style="position:absolute;bottom:4px;right:4px;background:rgba(0,0,0,0.6);color:white;font-size:9px;padding:2px 4px;border-radius:2px;">Vimeo</span>' +
                 '</div>';
        } else {
          // Direct video file or other - create video preview with play icon overlay
          return '<div style="width:100%;height:100%;position:relative;background:linear-gradient(135deg, #667eea 0%, #764ba2 100%);display:flex;align-items:center;justify-content:center;">' +
                 '<video style="width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;" preload="metadata" muted>' +
                 '<source src="' + url + '#t=0.1" type="video/mp4">' +
                 '</video>' +
                 '<div style="position:absolute;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.3);z-index:1;">' +
                 '<svg width="40" height="40" viewBox="0 0 24 24" fill="white" style="filter:drop-shadow(0 2px 4px rgba(0,0,0,0.4));"><path d="M8 5v14l11-7z"/></svg>' +
                 '</div>' +
                 '</div>';
        }
      }

      function rebindThumbnails() {
        var newThumbs = thumbs ? thumbs.querySelectorAll('.community-gallery__thumb') : [];
        newThumbs.forEach(function(t, index) {
          t.setAttribute('tabindex', 0);
          
          t.onclick = function() {
            // Remove active from all
            newThumbs.forEach(function(x) { x.classList.remove('is-active'); });
            t.classList.add('is-active');
            currentIndex = index;
            // 滚动缩略图到可见区域
            scrollToThumbnail(index);

            // Sync dots
            if (dots) {
              var dotEls = dots.querySelectorAll('.community-gallery__dot');
              if (dotEls.length) {
                dotEls.forEach(function(d) { d.classList.remove('is-active'); });
                if (dotEls[index]) {
                  dotEls[index].classList.add('is-active');
                }
              }
            }

            if (currentMode === 'videos') {
              // Handle video click
              var videoUrl = t.getAttribute('data-video-url');
              if (videoUrl && main) {
                var videoHTML = createVideoEmbed(videoUrl);
                main.style.opacity = '0';
                setTimeout(function() {
                  main.innerHTML = videoHTML;
                  main.style.opacity = '1';
                }, 160);
              }
            } else {
              // Handle image click (original functionality)
              var src = t.getAttribute('data-src');
              if (src && main) {
                var img = main.querySelector('img');
                if (img) {
                  img.style.opacity = '0';
                  setTimeout(function() {
                    img.src = src;
                    img.setAttribute('data-image-index', t.getAttribute('data-index') || '0');
                    img.style.opacity = '1';
                  }, 160);
                }
              }
            }
          };

          t.onkeydown = function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              t.click();
            }
          };
        });

        // Rebind dot clicks to sync with new thumbnails
        if (dots) {
          var dotEls = dots.querySelectorAll('.community-gallery__dot');
          dotEls.forEach(function(dot, index) {
            dot.onclick = function() {
              if (newThumbs[index]) {
                newThumbs[index].click();
              }
            };
          });
        }
      }

      // Re-add navigation arrows after content change
      function addNavigationArrows() {
        // Remove existing arrows if any
        var existingArrows = main.querySelectorAll('.community-gallery__nav');
        existingArrows.forEach(function(arrow) { arrow.remove(); });

        // Don't add arrows in video mode
        if (currentMode === 'videos') {
          return;
        }

        // Create and add new arrows
        var prevArrow = document.createElement('div');
        prevArrow.className = 'community-gallery__nav community-gallery__nav--prev';
        prevArrow.setAttribute('data-nav', 'prev');
        prevArrow.setAttribute('aria-label', 'Previous image');
        prevArrow.innerHTML = '<button type="button" class="community-gallery__nav-btn" aria-label="Previous"><svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>';
        prevArrow.addEventListener('click', function(e) {
          e.stopPropagation();
          navigateToIndex(currentIndex - 1);
        });

        var nextArrow = document.createElement('div');
        nextArrow.className = 'community-gallery__nav community-gallery__nav--next';
        nextArrow.setAttribute('data-nav', 'next');
        nextArrow.setAttribute('aria-label', 'Next image');
        nextArrow.innerHTML = '<button type="button" class="community-gallery__nav-btn" aria-label="Next"><svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>';
        nextArrow.addEventListener('click', function(e) {
          e.stopPropagation();
          navigateToIndex(currentIndex + 1);
        });

        main.appendChild(prevArrow);
        main.appendChild(nextArrow);
      }

      // Bind button events
      if (btnFeatures) {
        btnFeatures.addEventListener('click', switchToFeatures);
      }
      if (btnVideos) {
        btnVideos.addEventListener('click', switchToVideos);
      }

      // Add-ons toggle functionality - support multiple addon sections with different block IDs
      var addonsToggleBtns = root.querySelectorAll('.community-addons-toggle');
      
      console.log('[Addons Toggle] Found toggle buttons:', addonsToggleBtns.length);
      
      addonsToggleBtns.forEach(function(addonsToggleBtn, btnIndex) {
        console.log('[Addons Toggle] Processing button #' + btnIndex + ':', addonsToggleBtn);
        console.log('[Addons Toggle] Button visible:', addonsToggleBtn.offsetWidth > 0 && addonsToggleBtn.offsetHeight > 0);
        console.log('[Addons Toggle] Button styles:', {
          display: window.getComputedStyle(addonsToggleBtn).display,
          visibility: window.getComputedStyle(addonsToggleBtn).visibility,
          opacity: window.getComputedStyle(addonsToggleBtn).opacity
        });
        
        addonsToggleBtn.addEventListener('click', function() {
          console.log('[Addons Toggle] Button clicked!');
          
          // Find the button ID to match with the addons list
          var btnId = addonsToggleBtn.id;
          var blockId = btnId.replace('community-addons-toggle-', '');
          
          console.log('[Addons Toggle] Button ID:', btnId, 'Block ID:', blockId);
          
          // Find the corresponding addons list and section
          var addonsList = document.getElementById('community-addons-list-' + blockId);
          console.log('[Addons Toggle] Found addons list:', addonsList);
          
          // Find the parent block that contains both the section and the list
          var parentBlock = addonsToggleBtn.closest('.community-info-block');
          console.log('[Addons Toggle] Parent block:', parentBlock);
          
          var addonsSection = parentBlock ? parentBlock.querySelector('.community-addons-section') : null;
          console.log('[Addons Toggle] Found addons section:', addonsSection);
          
          if (addonsSection && addonsList) {
            var isExpanded = addonsSection.classList.contains('is-expanded');
            console.log('[Addons Toggle] Current expanded state:', isExpanded);
            var toggleText = addonsToggleBtn.querySelector('.community-addons-toggle__text');
            
            if (isExpanded) {
              // Collapse
              addonsSection.classList.remove('is-expanded');
              addonsToggleBtn.setAttribute('aria-expanded', 'false');
              if (toggleText) toggleText.textContent = '显示更多';
              console.log('[Addons Toggle] Collapsed');
            } else {
              // Expand
              addonsSection.classList.add('is-expanded');
              addonsToggleBtn.setAttribute('aria-expanded', 'true');
              if (toggleText) toggleText.textContent = '显示较少';
              console.log('[Addons Toggle] Expanded');
            }
          } else {
            console.error('[Addons Toggle] Could not find addons section!');
          }
        });
      });

      // Add to cart form: ensure correct variant (already set via hidden input)
      // No extra JS required here; normal form submission will add to cart.

      // Image zoom lightbox functionality
      var zoomBtn = document.getElementById('community-zoom-btn-' + sectionId);
      var lightbox = document.getElementById('community-lightbox-' + sectionId);
      var lightboxClose = document.getElementById('community-lightbox-close-' + sectionId);
      var lightboxImg = document.getElementById('community-lightbox-img-' + sectionId);
      var lightboxPrev = document.getElementById('community-lightbox-prev-' + sectionId);
      var lightboxNext = document.getElementById('community-lightbox-next-' + sectionId);
      var lightboxThumbsContainer = document.getElementById('community-lightbox-thumbs-' + sectionId);
      var lightboxThumbs = lightboxThumbsContainer ? lightboxThumbsContainer.querySelectorAll('.community-lightbox__thumb') : [];
      var currentLightboxIndex = 0;

      function openLightbox() {
        if (!lightbox) return;
        
        // Get current image index from main gallery
        var mainImg = main.querySelector('img');
        if (mainImg) {
          var currentIndex = parseInt(mainImg.getAttribute('data-image-index')) || 0;
          currentLightboxIndex = currentIndex;
          
          // Set lightbox image
          if (lightboxThumbs[currentIndex]) {
            var src = lightboxThumbs[currentIndex].getAttribute('data-lightbox-src');
            var alt = lightboxThumbs[currentIndex].querySelector('img').alt;
            lightboxImg.src = src;
            lightboxImg.alt = alt;
            
            // Update active thumb
            lightboxThumbs.forEach(function(t) { t.classList.remove('is-active'); });
            lightboxThumbs[currentIndex].classList.add('is-active');
          }
        }
        
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      function navigateLightbox(direction) {
        if (!lightboxThumbs.length) return;
        
        currentLightboxIndex += direction;
        
        // Wrap around
        if (currentLightboxIndex < 0) currentLightboxIndex = lightboxThumbs.length - 1;
        if (currentLightboxIndex >= lightboxThumbs.length) currentLightboxIndex = 0;
        
        // Update image with fade effect
        lightboxImg.style.opacity = '0';
        
        setTimeout(function() {
          var src = lightboxThumbs[currentLightboxIndex].getAttribute('data-lightbox-src');
          var alt = lightboxThumbs[currentLightboxIndex].querySelector('img').alt;
          lightboxImg.src = src;
          lightboxImg.alt = alt;
          
          // Update active thumb
          lightboxThumbs.forEach(function(t) { t.classList.remove('is-active'); });
          lightboxThumbs[currentLightboxIndex].classList.add('is-active');
          
          lightboxImg.style.opacity = '1';
        }, 150);
      }

      // Zoom button click
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          openLightbox();
        });
      }

      // Close button click
      if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox);
      }

      // Close on background click
      if (lightbox) {
        lightbox.addEventListener('click', function(e) {
          if (e.target === lightbox) {
            closeLightbox();
          }
        });
      }

      // Navigation buttons
      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', function(e) {
          e.stopPropagation();
          navigateLightbox(-1);
        });
      }
      
      if (lightboxNext) {
        lightboxNext.addEventListener('click', function(e) {
          e.stopPropagation();
          navigateLightbox(1);
        });
      }

      // Thumbnail clicks in lightbox
      lightboxThumbs.forEach(function(thumb, index) {
        thumb.addEventListener('click', function(e) {
          e.stopPropagation();
          currentLightboxIndex = index;
          
          lightboxImg.style.opacity = '0';
          
          setTimeout(function() {
            var src = thumb.getAttribute('data-lightbox-src');
            var alt = thumb.querySelector('img').alt;
            lightboxImg.src = src;
            lightboxImg.alt = alt;
            
            // Update active thumb
            lightboxThumbs.forEach(function(t) { t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
            
            lightboxImg.style.opacity = '1';
          }, 150);
        });
      });

      // Keyboard navigation in lightbox
      document.addEventListener('keydown', function(e) {
        if (!lightbox.classList.contains('is-open')) return;
        
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          navigateLightbox(-1);
        } else if (e.key === 'ArrowRight') {
          navigateLightbox(1);
        }
      });

      // Add-ons plus button toggle
      var addonPlusButtons = root.querySelectorAll('.community-addon-plus');
      addonPlusButtons.forEach(function(plusBtn) {
        plusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Toggle the is-added class
          plusBtn.classList.toggle('is-added');
        });
      });

      // Handle Add to Cart with selected add-ons
      var addToCartForm = root.querySelector('.community-add-to-cart');
      var buyNowForm = root.querySelector('.community-buy-now-form');
      
      if (addToCartForm) {
        addToCartForm.addEventListener('submit', function(e) {
          e.preventDefault();
          
          var submitBtn = addToCartForm.querySelector('.community-add__btn');
          
          // Show loading state
          submitBtn.classList.add('loading');
          submitBtn.disabled = true;
          
          // Collect all selected products
          var items = [];
          
          // Main product
          var mainVariantId = addToCartForm.querySelector('input[name="id"]').value;
          // 尝试获取数量，如果元素不存在则默认为1
          var qtyInputEl = addToCartForm.querySelector('.community-qty-input');
          var mainQty = qtyInputEl ? parseInt(qtyInputEl.value) || 1 : 1;
          
          console.log('[Add to Cart] Main variant ID:', mainVariantId, 'Quantity:', mainQty);
          
          if (mainVariantId) {
            items.push({
              id: mainVariantId,
              quantity: mainQty
            });
          }
          
          // Selected add-ons (GT Care + Add-on Products)
          var selectedAddons = root.querySelectorAll('.community-addon-plus.is-added');
          selectedAddons.forEach(function(addon) {
            var card = addon.closest('.community-addon-care, .community-addon-card');
            if (card) {
              var link = card.getAttribute('href');
              if (link) {
                // Extract product handle from URL
                var handle = link.replace('/products/', '').split('?')[0];
                // Get variant ID from data attribute if exists
                var variantId = card.getAttribute('data-variant-id');
                if (variantId) {
                  items.push({
                    id: variantId,
                    quantity: 1
                  });
                }
              }
            }
          });
          
          // Add all items to cart
          if (items.length > 0) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ items: items })
            })
            .then(response => response.json())
            .then(data => {
              console.log('Added to cart:', data);
              
              // Trigger cart update event
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              
              // Fetch updated cart and open notification
              return fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  openCartNotification(data, cart);
                  return data;
                });
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
              alert('Failed to add item to cart. Please try again.');
            })
            .finally(function() {
              // Hide loading state
              submitBtn.classList.remove('loading');
              submitBtn.disabled = false;
            });
          } else {
            // Hide loading state if no items
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
          }
        });
      }
      
      // Open cart notification function
      function openCartNotification(addedItem, cart) {
        console.log('[Cart Notification] === OPENING CART NOTIFICATION ===');
        console.log('[Cart Notification] Added item:', addedItem);
        console.log('[Cart Notification] Cart:', cart);
        
        var cartNotification = document.querySelector('cart-notification');
        console.log('[Cart Notification] Found cart-notification element:', !!cartNotification);
        
        if (cartNotification) {
          var notificationEl = cartNotification.querySelector('#cart-notification');
          console.log('[Cart Notification] Found #cart-notification:', !!notificationEl);
          
          if (!notificationEl) {
            console.error('[Cart Notification] #cart-notification element not found!');
            showFallbackNotification();
            return;
          }
          
          // Update cart notification product info
          var productInfo = cartNotification.querySelector('#cart-notification-product');
          if (productInfo && addedItem) {
            console.log('[Cart Notification] Updating product info');
            var itemData = Array.isArray(addedItem) ? addedItem[0] : addedItem;
            
            if (itemData && itemData.id) {
              var productHandle = root.getAttribute('data-product-handle');
              console.log('[Cart Notification] Product handle:', productHandle);
              
              if (productHandle) {
                fetch('/products/' + productHandle + '.js')
                  .then(response => response.json())
                  .then(product => {
                    console.log('[Cart Notification] Product data received:', product.title);
                    var variant = product.variants.find(v => v.id == itemData.id);
                    if (variant) {
                      productInfo.innerHTML = 
                        '<div class="cart-notification-product__info" style="display: flex; gap: 16px; align-items: center;">' +
                        (product.featured_image ? 
                          '<img src="' + product.featured_image + '" alt="' + product.title + '" width="70" height="70" style="border-radius: 4px;">' : 
                          '') +
                        '<div>' +
                          '<h3 style="margin: 0; font-size: 14px; font-weight: 600;">' + product.title + '</h3>' +
                          (variant.title !== 'Default Title' ? '<p style="margin: 4px 0; font-size: 13px; color: #666;">' + variant.title + '</p>' : '') +
                          '<p style="margin: 4px 0; font-size: 13px; color: #666;">Quantity: ' + (itemData.quantity || 1) + '</p>' +
                        '</div>' +
                        '</div>';
                    }
                  })
                  .catch(err => console.error('[Cart Notification] Error fetching product:', err));
              }
            }
          }
          
          // Update cart button text
          if (cart) {
            var cartButton = cartNotification.querySelector('#cart-notification-button');
            if (cartButton) {
              var itemCount = cart.item_count || 0;
              cartButton.textContent = itemCount === 1 ? 'View cart (1 item)' : 'View cart (' + itemCount + ' items)';
            }
            
            // Update cart count bubbles
            var cartCountBubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count');
            console.log('[Cart Notification] Updating cart count bubbles:', cartCountBubbles.length);
            cartCountBubbles.forEach(function(bubble) {
              bubble.textContent = cart.item_count;
              if (cart.item_count > 0) {
                bubble.style.display = 'flex';
                bubble.classList.remove('hidden');
              }
            });
          }
          
          // Try custom element method first
          if (typeof cartNotification.open === 'function') {
            console.log('[Cart Notification] Calling custom element open() method');
            cartNotification.open();
          } else {
            // Manual display method
            console.log('[Cart Notification] Using manual display method');
            
            // Remove the display: none style from the {% style %} block
            var styleTag = cartNotification.querySelector('style');
            if (styleTag) {
              styleTag.remove();
            }
            
            // Force show all parent containers
            cartNotification.style.display = 'block';
            cartNotification.style.visibility = 'visible';
            cartNotification.style.opacity = '1';
            
            var wrapper = cartNotification.querySelector('.cart-notification-wrapper');
            if (wrapper) {
              wrapper.style.display = 'block';
              wrapper.style.visibility = 'visible';
              wrapper.style.opacity = '1';
            }
            
            // Show the notification with animation
            notificationEl.style.display = 'block';
            notificationEl.style.visibility = 'visible';
            notificationEl.style.opacity = '0';
            notificationEl.style.transform = 'translateY(-20px)';
            notificationEl.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            
            // Add classes
            notificationEl.classList.add('active', 'animate');
            
            // Animate in
            setTimeout(function() {
              notificationEl.style.opacity = '1';
              notificationEl.style.transform = 'translateY(0)';
            }, 10);
            
            console.log('[Cart Notification] Notification should be visible now');
            console.log('[Cart Notification] Styles applied:', {
              cartNotification: window.getComputedStyle(cartNotification).display,
              wrapper: wrapper ? window.getComputedStyle(wrapper).display : 'N/A',
              notification: window.getComputedStyle(notificationEl).display
            });
            
            // Auto-hide after 5 seconds
            setTimeout(function() {
              notificationEl.style.opacity = '0';
              notificationEl.style.transform = 'translateY(-20px)';
              setTimeout(function() {
                notificationEl.style.display = 'none';
                notificationEl.classList.remove('active', 'animate');
              }, 300);
            }, 5000);
            
            // Add close button handler
            var closeBtn = notificationEl.querySelector('.cart-notification__close, .modal__close-button');
            if (closeBtn) {
              closeBtn.onclick = function(e) {
                e.preventDefault();
                console.log('[Cart Notification] Close button clicked');
                notificationEl.style.opacity = '0';
                notificationEl.style.transform = 'translateY(-20px)';
                setTimeout(function() {
                  notificationEl.style.display = 'none';
                  notificationEl.classList.remove('active', 'animate');
                }, 300);
              };
            }
            
            // Add continue shopping handler
            var continueBtn = cartNotification.querySelector('button[type="button"].link');
            if (continueBtn) {
              continueBtn.onclick = function(e) {
                e.preventDefault();
                console.log('[Cart Notification] Continue shopping clicked');
                notificationEl.style.opacity = '0';
                notificationEl.style.transform = 'translateY(-20px)';
                setTimeout(function() {
                  notificationEl.style.display = 'none';
                  notificationEl.classList.remove('active', 'animate');
                }, 300);
              };
            }
          }
        } else {
          console.error('[Cart Notification] cart-notification element not found in DOM');
          showFallbackNotification();
        }
      }
      
      // Fallback notification function
      function showFallbackNotification() {
        console.log('[Cart Notification] Using fallback notification');
        
        // Try cart drawer
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          console.log('[Cart Notification] Opening cart drawer');
          cartDrawer.open();
          return;
        }
        
        // Last resort: simple alert
        var notification = document.createElement('div');
        notification.innerHTML = 
          '<div style="position: fixed; top: 20px; right: 20px; background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 9999; max-width: 300px;">' +
            '<div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">' +
              '<svg width="20" height="20" viewBox="0 0 20 20" fill="green"><path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm-2 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z"/></svg>' +
              '<strong>Added to cart!</strong>' +
            '</div>' +
            '<a href="/cart" style="display: block; text-align: center; padding: 10px; background: #000; color: #fff; text-decoration: none; border-radius: 4px;">View Cart</a>' +
          '</div>';
        document.body.appendChild(notification.firstChild);
        
        setTimeout(function() {
          notification.firstChild.remove();
        }, 3000);
      }

      // Handle Buy Now with selected add-ons
      if (buyNowForm) {
        buyNowForm.addEventListener('submit', function(e) {
          e.preventDefault();
          
          var submitBtn = buyNowForm.querySelector('.community-buy-now__btn');
          
          // Show loading state
          submitBtn.classList.add('loading');
          submitBtn.disabled = true;
          
          // Collect all selected products
          var items = [];
          
          // Main product
          var mainVariantId = buyNowForm.querySelector('input[name="id"]').value;
          var mainQty = parseInt(buyNowForm.querySelector('.community-buy-now-qty').value) || 1;
          
          if (mainVariantId) {
            items.push({
              id: mainVariantId,
              quantity: mainQty
            });
          }
          
          // Selected add-ons
          var selectedAddons = root.querySelectorAll('.community-addon-plus.is-added');
          selectedAddons.forEach(function(addon) {
            var card = addon.closest('.community-addon-care, .community-addon-card');
            if (card) {
              var variantId = card.getAttribute('data-variant-id');
              if (variantId) {
                items.push({
                  id: variantId,
                  quantity: 1
                });
              }
            }
          });
          
          // Clear cart first, then add selected items and redirect to checkout
          if (items.length > 0) {
            fetch('/cart/clear.js', {
              method: 'POST'
            })
            .then(function() {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: items })
              });
            })
            .then(response => response.json())
            .then(data => {
              console.log('Buy Now: cleared cart and added selected items:', data);
              // Redirect to checkout for Buy Now
              window.location.href = '/checkout';
            })
            .catch(error => {
              console.error('Error in Buy Now process:', error);
              // Fallback: try direct checkout with main product only
              var checkoutUrl = '/cart/' + mainVariantId + ':' + mainQty;
              window.location.href = checkoutUrl;
              
              // Hide loading state on error
              submitBtn.classList.remove('loading');
              submitBtn.disabled = false;
            });
          } else {
            // Hide loading state if no items
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
          }
        });
      }
      
      // 缩略图滚动功能
      initThumbnailNavigation();
      
      // 滚动到指定的缩略图
      function scrollToThumbnail(index) {
        var thumbsContainer = document.getElementById('community-thumbs-' + sectionId);
        if (!thumbsContainer) return;
        
        var allThumbs = thumbsContainer.querySelectorAll('.community-gallery__thumb');
        if (!allThumbs[index]) return;
        
        var targetThumb = allThumbs[index];
        var containerWidth = thumbsContainer.clientWidth;
        var scrollLeft = thumbsContainer.scrollLeft;
        
        // 获取缩略图位置信息
        var thumbLeft = targetThumb.offsetLeft;
        var thumbWidth = targetThumb.offsetWidth;
        var thumbRight = thumbLeft + thumbWidth;
        
        // 计算可见区域
        var visibleLeft = scrollLeft;
        var visibleRight = scrollLeft + containerWidth;
        
        // 添加边距
        var margin = 20;
        
        // 判断是否需要滚动
        var needScroll = false;
        var targetScroll = scrollLeft;
        
        if (thumbLeft < visibleLeft + margin) {
          // 缩略图在左边不可见或太靠近边缘，需要向左滚动
          targetScroll = Math.max(0, thumbLeft - margin);
          needScroll = true;
        } else if (thumbRight > visibleRight - margin) {
          // 缩略图在右边不可见或太靠近边缘，需要向右滚动
          targetScroll = Math.min(
            thumbsContainer.scrollWidth - containerWidth,
            thumbRight - containerWidth + margin
          );
          needScroll = true;
        }
        
        if (needScroll) {
          thumbsContainer.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        }
      }
      
      function initThumbnailNavigation() {
        var thumbsContainer = document.getElementById('community-thumbs-' + sectionId);
        var thumbsPrev = document.getElementById('thumbs-prev-' + sectionId);
        var thumbsNext = document.getElementById('thumbs-next-' + sectionId);
        
        if (!thumbsContainer || !thumbsPrev || !thumbsNext) return;
        
        var scrollAmount = 150; // 每次滚动的像素数
        
        // 检查是否需要显示箭头
        function updateArrowVisibility() {
          var canScrollLeft = thumbsContainer.scrollLeft > 0;
          var canScrollRight = thumbsContainer.scrollLeft < (thumbsContainer.scrollWidth - thumbsContainer.clientWidth);
          
          if (canScrollLeft) {
            thumbsPrev.classList.remove('hidden');
          } else {
            thumbsPrev.classList.add('hidden');
          }
          
          if (canScrollRight) {
            thumbsNext.classList.remove('hidden');
          } else {
            thumbsNext.classList.add('hidden');
          }
          
          // 如果内容不需要滚动，隐藏所有箭头
          if (thumbsContainer.scrollWidth <= thumbsContainer.clientWidth) {
            thumbsPrev.classList.add('hidden');
            thumbsNext.classList.add('hidden');
          }
        }
        
        // 初始化箭头显示状态
        setTimeout(updateArrowVisibility, 100);
        
        // 监听容器大小变化
        if (window.ResizeObserver) {
          var resizeObserver = new ResizeObserver(updateArrowVisibility);
          resizeObserver.observe(thumbsContainer);
        }
        
        // 监听滚动事件
        thumbsContainer.addEventListener('scroll', updateArrowVisibility);
        
        // 左箭头点击事件
        thumbsPrev.addEventListener('click', function() {
          thumbsContainer.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
          });
        });
        
        // 右箭头点击事件
        thumbsNext.addEventListener('click', function() {
          thumbsContainer.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        });
        
        // 鼠标滚轮支持（可选）
        thumbsContainer.addEventListener('wheel', function(e) {
          if (e.deltaX !== 0) return; // 如果已经在水平滚动，不干预
          
          e.preventDefault();
          thumbsContainer.scrollBy({
            left: e.deltaY > 0 ? scrollAmount : -scrollAmount,
            behavior: 'smooth'
          });
        });
      }

      // 详情视频加载处理
      initDetailVideoHandling();
    });
  });

  // 详情视频处理函数
  function initDetailVideoHandling() {
    var videoContainers = document.querySelectorAll('.community-detail-video-container');
    
    videoContainers.forEach(function(container) {
      var videos = container.querySelectorAll('video');
      var iframes = container.querySelectorAll('iframe');
      
      // 处理HTML5视频
      videos.forEach(function(video) {
        // 添加加载状态
        container.classList.add('loading');
        
        video.addEventListener('loadstart', function() {
          container.classList.add('loading');
        });
        
        video.addEventListener('canplay', function() {
          container.classList.remove('loading');
        });
        
        video.addEventListener('error', function(e) {
          container.classList.remove('loading');
          console.error('Video loading error:', e);
          
          // 创建错误提示
          var errorMsg = document.createElement('div');
          errorMsg.style.cssText = 'padding: 20px; text-align: center; color: #666; background: #f5f5f5; border-radius: 8px;';
          errorMsg.innerHTML = '视频加载失败。<a href="' + video.currentSrc + '" target="_blank">点击此处尝试直接访问</a>';
          
          video.style.display = 'none';
          container.appendChild(errorMsg);
        });
        
        // 强制设置视频属性
        video.setAttribute('controls', 'true');
        video.setAttribute('preload', 'none');
        video.style.backgroundColor = '#000';
        
        // 如果没有poster，设置一个透明的1x1像素的data URI作为poster
        if (!video.poster) {
          video.poster = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9InRyYW5zcGFyZW50Ii8+PC9zdmc+';
        }
      });
      
      // 处理iframe (YouTube, Vimeo等)
      iframes.forEach(function(iframe) {
        container.classList.add('loading');
        
        iframe.addEventListener('load', function() {
          container.classList.remove('loading');
        });
        
        iframe.addEventListener('error', function(e) {
          container.classList.remove('loading');
          console.error('Iframe loading error:', e);
        });
        
        // 设置iframe属性
        iframe.style.backgroundColor = '#000';
      });
      
      // 如果没有视频或iframe，移除加载状态
      if (videos.length === 0 && iframes.length === 0) {
        container.classList.remove('loading');
      }
    });
  }
})();
